var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "justify-content": "flex-start",
        margin: "0px 3px",
        "flex-wrap": "wrap"
      }
    },
    [
      _c(
        "span",
        { staticStyle: { "font-size": "12px", "font-weight": "bold" } },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._l(_vm.dynamicChildren, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticStyle: { "padding-right": "2px", "font-size": "12px" }
          },
          [
            _c("div", {
              staticClass: "input-div",
              style: { width: item.text.length * 5 + 25 + "px" },
              domProps: { textContent: _vm._s(item.text) }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }